
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"59","height":"59","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.527 8.604h41.946v5.827H8.527V8.604z","fill":"#F88987"}}),_c('path',{attrs:{"d":"M12.698 42.29h.046a.808.808 0 00.762-.852l-.139-2.526a.808.808 0 00-1.613.087l.138 2.527a.807.807 0 00.806.764zm34.594-19.126a.808.808 0 00-.85.762l-1.689 31.271H14.246l-.518-9.61a.808.808 0 10-1.614.087l.56 10.371a.807.807 0 00.806.764h32.035a.806.806 0 00.805-.764l1.73-32.035a.806.806 0 00-.758-.846zm3.181-15.366H45.92a.807.807 0 000 1.613h3.745v4.213H9.334V9.411h32.811a.806.806 0 100-1.613H39.48V2.996a.807.807 0 00-.806-.807H20.327a.807.807 0 00-.806.807v4.802H8.527a.807.807 0 00-.806.806v5.827a.807.807 0 00.806.807h1.946l1.046 19.374a.807.807 0 00.805.763h.046a.807.807 0 00.76-.85l-1.04-19.288h34.822l-.208 3.854a.807.807 0 00.762.849h.046a.806.806 0 00.804-.764l.213-3.94h1.945a.806.806 0 00.806-.807V8.604a.806.806 0 00-.806-.806zM21.134 3.803h16.732v3.995H21.134V3.803z","fill":"#222"}}),_c('path',{attrs:{"d":"M22.317 43.701V24.276a.807.807 0 10-1.613 0v19.425a.807.807 0 001.613 0zm7.99 0V24.276a.806.806 0 10-1.614 0v19.425a.807.807 0 101.614 0zm7.989 0V24.276a.807.807 0 10-1.613 0v19.425a.807.807 0 001.613 0z","fill":"#222"}})])
          )
        }
      }
    